
import { Vue, Component } from 'vue-property-decorator';
@Component({
    name: 'Footer',
    components: {},
})

export default class Footer extends Vue {
    public agreement(): void {
        this.$router.push({ name: 'agreement' });
    }
}
